import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForProductElementComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'name',
    'product',
    'category',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      isMainColumn: true,
    },
    {
      property: 'product',
      type: 'relation',
    },
    {
      property: 'category',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
